import { useEffect, useState } from 'react';
import styles from './index.module.scss';
import { useTranslation } from 'react-i18next';
import Img from '@/component/Img';
import { Stage, COUNTDOWN } from './const';
import Phone from './phone';
import Varify from './varify';
import useScreenWidthBelowThreshold from '@/hooks/useScreenWidthBelowThreshold';
import cx from 'classnames';

export default function Login({ appEnv }) {
  const { t } = useTranslation();
  const [stage, setStage] = useState(Stage.Start);
  const isScreenWidthBelow700px = useScreenWidthBelowThreshold(700);
  const [mobileUpdated, setMobileUpdated] = useState(0);
  const [showVerify, setShowVerify] = useState(false);
  const [countdown, setCountdown] = useState(COUNTDOWN);

  useEffect(() => {
    let time;
    if (showVerify) {
      if (!countdown) return;
      time = setTimeout(() => {
        setCountdown(countdown - 1);
      }, 1000);
    }
    return () => clearTimeout(time);
  }, [showVerify, countdown]);

  useEffect(() => {
    setCountdown(COUNTDOWN);
  }, [mobileUpdated]);

  const [countryCode, setCountryCode] = useState('+1');
  const [mobileNumber, setMobileNumber] = useState();

  useEffect(() => {
    // 适配移动端 调整rem对应的设计稿尺寸
    if (isScreenWidthBelow700px) {
      document.documentElement.style.fontSize = 'calc(100vw / 3.75)';
    } else {
      document.documentElement.style.fontSize = 'calc(100vw / 19.20)';
    }
  }, [isScreenWidthBelow700px]);

  return (
    <div className={cx(styles.loginWrapper, { [styles.mobile]: isScreenWidthBelow700px })}>
      <div className={styles.login}>
        {stage === Stage.Start && (
          <>
            <div className={styles.icon} />
            <div className={styles.title}>{t('DUET_WEB_SIGNIN_START_TITLE')}</div>
            <div className={styles.subTitle}>{t('DUET_WEB_SIGNIN_START_CONTENT')}</div>
            <div className={styles.button} onClick={() => setStage(Stage.Phone)}>
              <Img
                src="https://cdn.duetapp.net/v1/images/eyJpZCI6IllFNVY0U1hXWVdTTVZKQVBBNko3T1hLVkNUVk5TUSIsInciOjMyLCJoIjozNCwiZCI6MCwibXQiOiJpbWFnZS9qcGVnIiwiZGgiOjMxMTIzMTU4MjU1ODM4Mjc3NTV9"
                alt=""
              />
              {t('DUET_WEB_SIGNIN_START_BUTTON')}
            </div>
          </>
        )}
        {stage === Stage.Phone && (
          <Phone
            setStage={setStage}
            setCountryCode={setCountryCode}
            countryCode={countryCode}
            mobileNumber={mobileNumber}
            setMobileNumber={setMobileNumber}
            setMobileUpdated={setMobileUpdated}
            setShowVerify={setShowVerify}
            countdown={countdown}
            showVerify={showVerify}
            appEnv={appEnv}
          />
        )}
        {stage === Stage.Varify && (
          <Varify
            setStage={setStage}
            mobileNumber={mobileNumber}
            countryCode={countryCode}
            countdown={countdown}
            setCountdown={setCountdown}
          />
        )}
      </div>
    </div>
  );
}
